import { Injectable } from '@angular/core';
import { ReplaySubject } from 'rxjs/ReplaySubject';
import { Http } from '@angular/http';
import { utilityService } from '../../sharedcomponents/commonservice/utility.service';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class PaymentreceiptService {

  private cartDetail = new ReplaySubject<any>();
  private singlecartDetail = new ReplaySubject<any>();

  constructor(private http: Http,
    private utilserv: utilityService) { }
  // 1 Envolpe for
  setCartReceiptData(dataValues: any) {
    this.cartDetail.next(dataValues);
  }

  getCartReceiptData(): Observable<any> {
    return this.cartDetail.asObservable();
  }

  setIndivisualorderData(dataValues: any) {
    dataValues.showBothScreen= true;
    dataValues.mobileScreen = true;
    this.singlecartDetail.next(dataValues);
  }

  geIndivisualtRepeatorderData(): Observable<any> {
    return this.singlecartDetail.asObservable();
  }


}



// WEBPACK FOOTER //
// ./src/app/_services/paymentreceipt/paymentreceipt.service.ts